import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toastNotify } from '../../utils/toastNotify';
import { dwollaAgreementsApi } from '../../services/authApi/userApi';
const initialState = {
  loading: false
};
export const dwollaAgreementsAction = createAsyncThunk('DWOLLA_AGREEMENTS', dwollaAgreementsApi);

export const onbordingSlice = createSlice({
  name: 'dwollaAgreement',
  initialState,
  extraReducers: {
    [dwollaAgreementsAction.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [dwollaAgreementsAction.fulfilled]: (state) => {
      return {
        ...state,
        loading: false
      };
    },
    [dwollaAgreementsAction.rejected]: (state, action) => {
      toastNotify('error', action.payload);
      return {
        ...state,
        loading: false
      };
    },
  },
});

const { reducer } = onbordingSlice;
export default reducer;
